import { EColor, EIcon, ESize } from '@core/type';

import { ButtonIcon } from '../button/ButtonIcon';
import { Box } from '../layout/Box';
import { ModalBody } from './ModalBody';
import { ModalFooter } from './ModalFooter';
import { ModalHeader } from './ModalHeader';
import { ModalStyled } from './ModalStyled';
import { ModalProps } from './interface-modal';

const ModalWithoutPadding = ({ isOpen, children, onCloseModal, size = ESize.MD }: ModalProps) => {
  return (
    <ModalStyled isOpen={isOpen} onCloseModal={onCloseModal} size={size}>
      <Box top="24px" right="24px" position="absolute" cursor="pointer">
        <ButtonIcon
          onClick={onCloseModal}
          iconProps={{
            type: EIcon.CROSS,
            color: EColor.SECONDARY,
          }}
        />
      </Box>
      {children}
    </ModalStyled>
  );
};

ModalWithoutPadding.Header = ModalHeader;
ModalWithoutPadding.Body = ModalBody;
ModalWithoutPadding.Footer = ModalFooter;

export { ModalWithoutPadding };
